<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-row>
        <el-col :span="8">
          <el-form-item>
            <el-button type="primary" size="medium" @click="importUser()">+创建用户</el-button>
            <el-button size="medium" @click="deleDatch()">批量删除</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange" :reserve-selection="true" height="60vh">
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <!-- <el-table-column label="用户编号" width="300">
        <template slot-scope="scope">{{scope.row.userNum}}</template>
      </el-table-column> -->
      <el-table-column label="用户类型">
        <template slot-scope="scope">{{scope.row.userType}}</template>
      </el-table-column>
      <!-- <el-table-column label="账号状态">
        <template slot-scope="scope">{{scope.row.userState | userStateType}}</template>
      </el-table-column> -->
      <!-- <el-table-column label="注册时间">
        <template slot-scope="scope">{{scope.row.createdDate | formatDateTimeDefault}}</template>
      </el-table-column> -->
      <el-table-column label="注册手机号">
        <template slot-scope="scope">{{scope.row.phone}}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goCheck(scope.row.id)">查看</el-button>
          <el-button type="text" @click="delectUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum" :page-size="search.pageSize" :page-sizes="[10,20]" :total="total">
      </el-pagination>

    </div>

    <el-row type="flex" justify="end" class="orderEdit">
      <el-col :span="5">
        <el-button @click="cancel()">
          取消
        </el-button>
        <el-button @click="confirm()" type="primary">
          确认
        </el-button>
      </el-col>
    </el-row>

    <el-dialog title="用户创建" :visible.sync="dialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="download" size="medium">
              <div class="btnclass">
                <img src="../../assets/download.png" alt="">
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="fileupload" @addUpload="importUpdateStockByExcel" :title="'+导入excel文件'" :limit="1" size="medium" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="cancelExcel()">取 消</div>
        <div @click="submitExcel()">确认导入</div>
      </div>
    </el-dialog>

  </div>

</template>

<script>
import FileUpload from '@/components/Upload/fileUpload';
export default {
  name: 'home',
  components: { FileUpload },
  data() {
    return {
      list: [],
      search: {
        pageSize: 10,
        pageNum: 1,
      },
      isEdit: false,
      listLoading: false,
      dialogVisible: false,
      userTypeList: [
        {
          label: "用户",
          value: "1",
        },
        {
          label: "回收员",
          value: "2",
        },
        {
          label: "网点",
          value: "3",
        },
      ],
      userStateList: [
        {
          label: "冻结",
          value: "0",
        },
        {
          label: "可用",
          value: "1",
        },
      ],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      upLoadData: {},
      key: '',
    }
  },
  filters: {
    userStateType(value) {
      if (value) {
        return '可用'
      } else {
        return '冻结'
      }
    },
    userType(value) {
      if (value === 1) {
        return '用户'
      } else if (value === 2) {
        return '回收员'
      } else {
        return '网点'
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.query.key) {
        vm.key = from.query.key
        vm.getList()
      }
    });
  },
  created() {
    // this.getList()
    console.log(this.$route, "route")
  },
  methods: {
    getList() {
      let { pageSize, pageNum, } = this.search || ''
      let params = {
        key: this.key,
        pageSize: pageSize,
        pageNum: pageNum,
      }
      this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryUser/getUserImportList', params).then(res => {
        if (res.statusCode === 200)
          this.total = res.total
        this.arr = res.data
        this.list = this.arr.slice(0, this.search.pageSize)
      })
    },
    importUser() {
      this.dialogVisible = true
    },
    handleSelectionChange(rows) {
      // console.log(rows);
      // this.allSelectedIds 所有页选中的数据
      // this.currentTableData  当前页所有的数据
      // selectedIds  选中的项
      // unSelectedIds  未选中的项
      const selectedIds = rows.map((item) => item.id);
      const unSelectedIds = this.list
        .map((item) => item.id)
        .filter((item) => !selectedIds.includes(item));
      // // 获的所有选中的项
      this.allSelectedIds = this.allSelectedIds.filter(
        (item) => !unSelectedIds.includes(item)
      );
      // // //获得未选中的项
      this.unSelectedIds = unSelectedIds
      // // 数组去重
      this.allSelectedIds = [
        ...new Set([...this.allSelectedIds, ...selectedIds]),
      ];
      console.log(this.allSelectedIds, "this.allSelectedIds")
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    delectUser(id) {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除此账户，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          if (id) {
            let params = {
              key: this.key,
              ids: [id]
            }
            this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryUser/delBatchUserImportByIds`, params).then(res => {
              if (res.statusCode === 200)
                this.$message.success('删除成功')
              this.getList()
            })
          }
        },
        onCancel: () => {
          console.log('cancel');
        }
      })
    },
    download() {
      this.global.exportExcel('/autoapp-recovery-server-auth/api/recoveryUser/downloadUserTemp', {}, '用户模版').catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
    goAdd() {
      this.$router.push({
        path: "/user/userAdd",
        query: {
        }
      });
    },
    goCheck(id) {
      this.$router.push({
        path: "/user/userCheck",
        query: {
          id: id,
          key: this.key,
        }
      });
    },
    deleDatch() {
      this.$dialog({
        title: '温馨提示',
        content: '是否要删除此账户，删除后不可以恢复！',
        cancel_buttton: '否',
        ok_buttton: '是',
        footBtn: false,
        width: '400px',
        footBtn: 'card',
        dialogType: 'delete',
        onOk: () => {
          this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryUser/delBatchUser', this.allSelectedIds).then(res => {
            this.$message.success('删除成功')
            this.getList()
          })
        },
        onCancel: () => {
          console.log('cancel');
        }
      })

    },
    importUpdateStockByExcel(item) {
      this.loading = true;
      this.upLoadData = item
    },
    submitExcel() {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        let formData = new FormData();
        formData.append("file", this.upLoadData.file);
        this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryUser/userImport', formData).then(res => {
          if (res.statusCode != 200) {
            this.$message.error(res.message)
          } else {
            this.$message.success('导入成功')
            this.key = res.data
            this.getList()
          }
        })
        this.cancelExcel()
      } else {
        this.$message.error('请上传文件')
      }

    },
    cancelExcel() {
      this.$refs.fileupload.$refs.upload.clearFiles()
      this.upLoadData = {}
      this.dialogVisible = false
    },
    cancel() {
      let params = {

      }
      this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryOrder/cancel/${this.key}`, params).then(res => {
        this.list = []
        this.key = ''
        this.getList()
      })
    },
    confirm() {
      let params = {

      }

      this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryUser/userTrueImport/${this.key}`, params).then(res => {
        this.$dialog({
          title: '温馨提示',
          content: '注册成功!',
          left_buttton: '取消',
          right_buttton: '确定',
          footBtn: false,
          width: '20%',
          dialogType: 'success',
          onOk: () => {
            console.log('ok');
          },
          onCancel: () => {
            console.log('cancel');
          }
        })
        this.getList()
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.row-bg {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.orderEdit {
  width: 100%;
}
.tableBtn {
  cursor: pointer; // 悬浮时变手指
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/userAdd.vue